export type Service = {
  slug: string;
  index: string;
  title: string;
  short: string;
  long: string;
  image: string;
  capabilities: string[];
};

export const services: Service[] = [
  {
    slug: 'chaudronnerie-industrielle',
    index: '01',
    title: 'Chaudronnerie industrielle',
    short:
      "Fabrication de cuves, silos et structures métalliques sur mesure, avec des techniques avancées pour garantir qualité et durabilité.",
    long:
      "Nos ateliers de Logbaba réalisent des ensembles chaudronnés sur mesure : cuves de stockage, silos, trémies, réservoirs, gaines et charpentes métalliques. Chaque ouvrage est étudié à partir de vos plans ou de nos relevés sur site, puis tracé, découpé, roulé, assemblé et contrôlé avant expédition.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.26.jpeg',
    capabilities: [
      "Cuves, silos, trémies et réservoirs",
      "Charpentes et structures métalliques",
      "Découpe, roulage et pliage de tôles",
      "Relevés dimensionnels sur site",
    ],
  },
  {
    slug: 'soudure-industrielle',
    index: '02',
    title: 'Soudure industrielle',
    short:
      "Expertise en soudure TIG, MIG et ARC pour des assemblages robustes et fiables, avec un contrôle qualité rigoureux à chaque étape.",
    long:
      "La soudure est le cœur de notre métier. Nos soudeurs interviennent en TIG, MIG/MAG et ARC sur aciers carbone, inoxydables et alliés. Les modes opératoires sont qualifiés, les paramètres tracés et les assemblages contrôlés visuellement et par ressuage lorsque le projet l'exige.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.39.37-1.jpeg',
    capabilities: [
      "Soudure TIG, MIG/MAG et ARC",
      "Aciers carbone, inox et alliés",
      "Modes opératoires qualifiés",
      "Contrôle visuel et ressuage",
    ],
  },
  {
    slug: 'tuyauterie-industrielle',
    index: '03',
    title: 'Tuyauterie industrielle',
    short:
      "Fabrication, assemblage et maintenance de tuyauteries acier et inox. Soudure certifiée et mise en service de vos réseaux industriels.",
    long:
      "Nous concevons et assemblons des réseaux de tuyauterie pour fluides, vapeur et air comprimé : préfabrication en atelier, isométriques, supportage, montage sur site et mise en service. La cohérence des diamètres, des pentes et des points de purge est vérifiée avant chaque essai.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.27.jpeg',
    capabilities: [
      "Préfabrication en atelier",
      "Isométriques et supportage",
      "Réseaux fluides, vapeur, air",
      "Essais et mise en service",
    ],
  },
  {
    slug: 'maintenance-industrielle',
    index: '04',
    title: 'Maintenance industrielle',
    short:
      "Maintenance préventive et corrective sur sites industriels pour prolonger la durée de vie de vos équipements.",
    long:
      "Nos équipes interviennent en maintenance préventive planifiée comme en dépannage d'urgence : inspection des équipements, remplacement de pièces d'usure, reprise de soudures, réparation de circuits et remise en conformité. Chaque intervention est documentée pour alimenter votre historique machine.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/ca84cb971abbca8924ed01dd0a41.jpeg',
    capabilities: [
      "Maintenance préventive planifiée",
      "Dépannage et arrêts d'urgence",
      "Reprise et réparation de soudures",
      "Rapports d'intervention détaillés",
    ],
  },
  {
    slug: 'montage-ouvrages-industriels',
    index: '05',
    title: "Montage d'ouvrages industriels",
    short:
      "Assemblage expert de charpentes, silos et cuves. Montage sécurisé de vos structures métalliques et équipements industriels sur site.",
    long:
      "Du levage à la mise en ligne, nous prenons en charge le montage de vos ouvrages : préparation des ancrages, calage, alignement, boulonnage et serrage contrôlé. Les opérations sont préparées avec un plan de levage et un plan de prévention adaptés à votre site.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.04.28.jpeg',
    capabilities: [
      "Charpentes et structures métalliques",
      "Silos, cuves et équipements",
      "Plans de levage et de prévention",
      "Alignement et serrage contrôlé",
    ],
  },
  {
    slug: 'peinture-industrielle',
    index: '06',
    title: 'Peinture industrielle',
    short:
      "Traitement de surface et protection anticorrosion, avec des peintures industrielles certifiées pour la longévité de vos structures.",
    long:
      "La protection anticorrosion prolonge la vie de vos ouvrages. Nous préparons les surfaces par dégraissage, brossage ou sablage, puis appliquons des systèmes de peinture adaptés à l'environnement : atmosphère saline, zone portuaire, ambiance humide ou produits chimiques.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/metal-painting2-687x318-1.jpg',
    capabilities: [
      "Préparation et sablage des surfaces",
      "Systèmes anticorrosion",
      "Peintures industrielles certifiées",
      "Contrôle d'épaisseur et d'adhérence",
    ],
  },
  {
    slug: 'formation',
    index: '07',
    title: 'Formation',
    short:
      "Formations théoriques et pratiques en chaudronnerie, tuyauterie, soudure et montage pour qualifier vos équipes.",
    long:
      "Notre centre transmet les gestes du métier : lecture de plans, traçage, coupage, soudure sur différents procédés, sécurité au poste. Les sessions alternent théorie, atelier et évaluation pratique afin que chaque participant reparte avec des compétences directement applicables.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-06-at-13.50.19.jpeg',
    capabilities: [
      "Chaudronnerie et tuyauterie",
      "Soudure multi-procédés",
      "Lecture de plans et traçage",
      "Évaluation pratique en fin de session",
    ],
  },
  {
    slug: 'placement-du-personnel',
    index: '08',
    title: 'Placement du personnel',
    short:
      "Sélection et mise à disposition de personnel qualifié, adapté à vos besoins opérationnels et à vos exigences de site.",
    long:
      "Nous identifions, évaluons et mettons à disposition des profils techniques opérationnels : soudeurs, chaudronniers, tuyauteurs, monteurs, échafaudeurs. La sélection tient compte de l'expérience, des habilitations et des contraintes de votre chantier.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/Capture-decran-2026-01-06-141247.png',
    capabilities: [
      "Soudeurs et chaudronniers",
      "Tuyauteurs et monteurs",
      "Évaluation technique des profils",
      "Mise à disposition flexible",
    ],
  },
  {
    slug: 'import-export',
    index: '09',
    title: 'Import / Export',
    short:
      "Approvisionnement, achat et acheminement sécurisé de vos marchandises et équipements industriels.",
    long:
      "Nous accompagnons vos projets à l'international : recherche de fournisseurs, achat d'équipements, contrôle avant expédition, dédouanement et acheminement jusqu'au site. Un interlocuteur unique suit votre dossier du bon de commande à la livraison.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-03-at-10.58.51.jpeg',
    capabilities: [
      "Sourcing et achat d'équipements",
      "Contrôle avant expédition",
      "Dédouanement et transit",
      "Livraison sur site",
    ],
  },
  {
    slug: 'monteur-echafaudage',
    index: '10',
    title: 'Monteur échafaudage',
    short:
      "Formation certifiante aux techniques de montage, démontage et sécurité des échafaudages industriels.",
    long:
      "Le travail en hauteur ne s'improvise pas. Cette formation couvre les vérifications avant montage, les règles de stabilité, les protections collectives, le port du harnais et les procédures de démontage. Elle se conclut par une évaluation pratique sur structure réelle.",
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/Echafaudeur-0284_ERANIAN_MG_0991.png',
    capabilities: [
      "Montage et démontage sécurisé",
      "Stabilité et protections collectives",
      "Travail en hauteur et harnais",
      "Évaluation pratique sur structure",
    ],
  },
];